import { render, staticRenderFns } from "./UserAccount.vue?vue&type=template&id=89a89ddc&scoped=true&"
import script from "./UserAccount.vue?vue&type=script&lang=js&"
export * from "./UserAccount.vue?vue&type=script&lang=js&"
import style0 from "./UserAccount.vue?vue&type=style&index=0&id=89a89ddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a89ddc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSwitch,VTextField})
